/**
 * Offer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Modification } from './modification';
import { Costs } from './costs';
import { SmilyBooking } from './smilyBooking';
import { BankProduct } from './bankProduct';
import { ContractStateHistoricalEntry } from './contractStateHistoricalEntry';
import { OfferResponse } from './offerResponse';
import { DocumentUpload } from './documentUpload';
import { DocumentForSignature } from './documentForSignature';
import { Identification } from './identification';
import { KreditInsurance } from './kreditInsurance';
import { Promotion } from './promotion';
import { VisitedPageHistoricalEntry } from './visitedPageHistoricalEntry';
import { CreditApplication } from './creditApplication';
import { BccAgentActivation } from './bccAgentActivation';
import { SmartOffer } from './smartOffer';
import { Checkbox } from './checkbox';
import { BankCheck } from './bankCheck';
import { TrackingData } from './trackingData';
import { OfferCoupon } from './offerCoupon';


export interface Offer { 
    id?: string;
    testMode?: boolean;
    type?: Offer.TypeEnum;
    updatedAt?: string;
    createdAt?: string;
    modifiedAt?: string;
    creditApplicationId?: string;
    customerId?: string;
    ssoUserId?: string;
    tracking?: TrackingData;
    bankProduct?: BankProduct;
    submitState?: Offer.SubmitStateEnum;
    contractState?: Offer.ContractStateEnum;
    contractStateFlow?: Offer.ContractStateFlowEnum;
    bankTermsAccepted?: boolean;
    checkboxes?: Array<Checkbox>;
    bankApplication?: CreditApplication;
    bankCheck?: BankCheck;
    modifications?: Array<Modification>;
    offerResponse?: OfferResponse;
    costs?: Costs;
    identification?: Identification;
    identifications?: Array<Identification>;
    documentUpload?: DocumentUpload;
    documentsForSignature?: Array<DocumentForSignature>;
    hasUnseenBccMessages?: boolean;
    bccAgent?: string;
    promotion?: Promotion;
    closingDate?: string;
    deductionState?: Offer.DeductionStateEnum;
    deductionDate?: string;
    executionDate?: string;
    contractToken?: string;
    protectedContractToken?: string;
    contractStateHistory?: Array<ContractStateHistoricalEntry>;
    visitedPageHistory?: Array<VisitedPageHistoricalEntry>;
    coupon?: OfferCoupon;
    offerBankSequence?: number;
    additionalData?: { [key: string]: object; };
    kreditInsurance?: KreditInsurance;
    smartOffer?: SmartOffer;
    smilyBooking?: SmilyBooking;
    bccAgentActive?: boolean;
    bccAgentActivationHistory?: Array<BccAgentActivation>;
    bccAlternativeOffer?: boolean;
    withdrawnAt?: string;
    contractDownloadedAt?: string;
}
export namespace Offer {
    export type TypeEnum = 'CUSTOMER' | 'AGENT' | 'SMART_OFFER' | 'ALTERNATIVE_OFFER' | 'ALTERNATIVE_SMART_OFFER';
    export const TypeEnum = {
        Customer: 'CUSTOMER' as TypeEnum,
        Agent: 'AGENT' as TypeEnum,
        SmartOffer: 'SMART_OFFER' as TypeEnum,
        AlternativeOffer: 'ALTERNATIVE_OFFER' as TypeEnum,
        AlternativeSmartOffer: 'ALTERNATIVE_SMART_OFFER' as TypeEnum
    };
    export type SubmitStateEnum = 'NEW' | 'SENDING' | 'SEND' | 'ERROR';
    export const SubmitStateEnum = {
        New: 'NEW' as SubmitStateEnum,
        Sending: 'SENDING' as SubmitStateEnum,
        Send: 'SEND' as SubmitStateEnum,
        Error: 'ERROR' as SubmitStateEnum
    };
    export type ContractStateEnum = 'NEW' | 'ERROR' | 'EXPIRED' | 'PRELIMINARY_ACCEPTED' | 'PRELIMINARY_OFFER' | 'REJECTED' | 'ACCEPTED' | 'IDENT_STARTED' | 'IDENT_FINISHED' | 'CLOSING_FINISHED' | 'DOCUMENTS_UPLOADED' | 'DOCUMENTS_UPLOADED_2ND' | 'DOCUMENTS_MISSING' | 'DOCUMENTS_MISSING_2ND' | 'DOCUMENTS_CHECKED' | 'DOCUMENTS_CHECKED_2ND' | 'REJECTED_2ND' | 'REJECTED_CLEARING' | 'CLOSED' | 'WITHDRAWN';
    export const ContractStateEnum = {
        New: 'NEW' as ContractStateEnum,
        Error: 'ERROR' as ContractStateEnum,
        Expired: 'EXPIRED' as ContractStateEnum,
        PreliminaryAccepted: 'PRELIMINARY_ACCEPTED' as ContractStateEnum,
        PreliminaryOffer: 'PRELIMINARY_OFFER' as ContractStateEnum,
        Rejected: 'REJECTED' as ContractStateEnum,
        Accepted: 'ACCEPTED' as ContractStateEnum,
        IdentStarted: 'IDENT_STARTED' as ContractStateEnum,
        IdentFinished: 'IDENT_FINISHED' as ContractStateEnum,
        ClosingFinished: 'CLOSING_FINISHED' as ContractStateEnum,
        DocumentsUploaded: 'DOCUMENTS_UPLOADED' as ContractStateEnum,
        DocumentsUploaded2Nd: 'DOCUMENTS_UPLOADED_2ND' as ContractStateEnum,
        DocumentsMissing: 'DOCUMENTS_MISSING' as ContractStateEnum,
        DocumentsMissing2Nd: 'DOCUMENTS_MISSING_2ND' as ContractStateEnum,
        DocumentsChecked: 'DOCUMENTS_CHECKED' as ContractStateEnum,
        DocumentsChecked2Nd: 'DOCUMENTS_CHECKED_2ND' as ContractStateEnum,
        Rejected2Nd: 'REJECTED_2ND' as ContractStateEnum,
        RejectedClearing: 'REJECTED_CLEARING' as ContractStateEnum,
        Closed: 'CLOSED' as ContractStateEnum,
        Withdrawn: 'WITHDRAWN' as ContractStateEnum
    };
    export type ContractStateFlowEnum = 'DEFAULT' | 'PRELIMINARY' | 'CLICKOUT';
    export const ContractStateFlowEnum = {
        Default: 'DEFAULT' as ContractStateFlowEnum,
        Preliminary: 'PRELIMINARY' as ContractStateFlowEnum,
        Clickout: 'CLICKOUT' as ContractStateFlowEnum
    };
    export type DeductionStateEnum = 'ENTITLED' | 'DEDUCTED' | 'DEDUCTED_CLICK' | 'DEDUCTED_LEAD' | 'DEDUCTED_ONGOING' | 'EXPIRED' | 'CANCELED' | 'NOT_AVAILABLE' | 'STORNO';
    export const DeductionStateEnum = {
        Entitled: 'ENTITLED' as DeductionStateEnum,
        Deducted: 'DEDUCTED' as DeductionStateEnum,
        DeductedClick: 'DEDUCTED_CLICK' as DeductionStateEnum,
        DeductedLead: 'DEDUCTED_LEAD' as DeductionStateEnum,
        DeductedOngoing: 'DEDUCTED_ONGOING' as DeductionStateEnum,
        Expired: 'EXPIRED' as DeductionStateEnum,
        Canceled: 'CANCELED' as DeductionStateEnum,
        NotAvailable: 'NOT_AVAILABLE' as DeductionStateEnum,
        Storno: 'STORNO' as DeductionStateEnum
    };
}


